
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/invitation",
      function () {
        return require("private-next-pages/bcks/invitation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/invitation"])
      });
    }
  